export function aboutPage() {
  return `
  <main class="wrap privacy-page">
    <h1>About &amp; terms</h1>
    <p class="lead">cruxdiff is built and maintained by Waris Chutani as an independent, privacy-first comparison tool.</p>

    <section>
      <h2>Why it exists</h2>
      <p>Most diffs show every changed line. cruxdiff is built to show the meaning underneath that noise: moved blocks, reordered keys, and records matched by identity rather than position.</p>
    </section>

    <section>
      <h2>Terms of use</h2>
      <p>cruxdiff is provided “as is,” without warranties of any kind. Results may be incomplete or incorrect, so review important comparisons yourself and use the tool at your own risk; cruxdiff and its maintainer are not liable for losses arising from its use.</p>
    </section>

    <section>
      <h2>Your data</h2>
      <p>Your comparison data stays in your browser. Read the <a href="/privacy.html">privacy and implementation details</a> for the precise claim and ways to verify it.</p>
    </section>

    <p class="back"><a href="/">← Back to cruxdiff</a></p>
  </main>`;
}

export function notFoundPage() {
  return `
  <main class="wrap privacy-page not-found-page">
    <p class="eyebrow">404 · not found</p>
    <h1>That page isn’t here</h1>
    <p class="lead">The address may be mistyped or the page may have moved. Your comparison tool is still right where you left it.</p>
    <p class="back"><a href="/">← Open cruxdiff</a></p>
  </main>`;
}
